import 'reflect-metadata'
import * as ReactDOM from 'react-dom/client'
import { App } from './app'
import { appSettings } from './config/app-settings'

// index.html ships a neutral static title because the real one is per-environment
// and must not be baked into the build. window.__ENV__ is injected in <head>
// ahead of this deferred module script, so the value is already available.
if (appSettings.AppFullName) {
  document.title = appSettings.AppFullName
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)
